import moment from 'moment';
import QRCode from 'qrcode';
import {barcodeMethod} from "./prototype-barcode";
import {
  remove_ie_header_and_footer,
  formatNumber,
  getWeek,
} from '@/utils';
import jsbarcode from 'jsbarcode';

let fontFamily = 'Microsoft YaHei,SimHei';

// 元亨
export function initYuanHengLabelFrame(
  {
    iframe,
    processingOrderNo,
    purchaseOrderNo,
    materialNo,
    specificationNo,
    deliveryDate,
    count,
    boxNo,
    index
  }) {
  const manufacturerLotNo = 'HZSX20160722';
  const supplier = '杭州视芯科技股份有限公司';
  const dateCode = moment(deliveryDate).format('YYYY-MM-DD');
  const dateCodeBatch = moment(deliveryDate).format('YYYYMMDD');
  const month = moment(deliveryDate).format('MM');
  const batchNo = `LOT/${processingOrderNo}/${purchaseOrderNo}/${manufacturerLotNo}/${dateCodeBatch}/${boxNo.replace('#', '')}`;
  const qrCodeText = `${batchNo}/${count}`;
  const canvasId = index === undefined ? 'yuanHengQrCode' : `yuanHengQrCode${index}`;
  let doc = iframe.contentWindow.document;
  let pageBreakBefore = index === undefined || index === 0 ? 'auto' : 'always';
  doc.writeln(`
    <html>
        <head>
            <style type="text/css" media="print">
                @page {
                    size: auto;
                    margin: 0mm;
                }
            </style>
            <style type="text/css">
                * {
                    margin: 0;
                    padding: 0;
                }
                .yuanHengLabel {
                    margin: 0 5px;
                    font-size: 12px;
                    box-sizing: border-box;
                    background: white;
                    page-break-before:${pageBreakBefore};
                    width: calc(100% - 10px);
                    height: calc(100% - 50px);
                    border: 1px solid #000;
                    border-collapse: collapse;
                }
                .yuanHengLabel .month {
                    width: 25px;
                    height: 25px;
                    margin-top: 2px;
                    border: 1px solid #000;
                    border-radius: 50%;
                    font-size: 22px;
                    padding: 8px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }
                .yuanHengLabel td {
                    padding: 0 0 0 10px;
                    line-height: 1;
                    font-family: ${fontFamily},serif;
                }
            </style>
        </head>
        <body>
          <table class="yuanHengLabel" border="1" cellspacing="0" cellpadding="0">
             <tbody>
              <tr>
                <td rowspan="9" align="center" valign="top">
                    <div style="display: flex; flex-direction: column; justify-content: space-between; align-items: center;">
                      <div class="month">${month}</div>
                      <canvas id="${canvasId}" style="zoom: 0.5; display: block; margin: 0 2px;"></canvas>
                      <p style="margin: 0px auto">${count}</p>
                      <p style="margin: 0px auto 2px">PCS</p>
                      <p style="margin: 2px auto;">${boxNo}</p>
                    </div>
                </td>
                <td>加工单号</td>
                <td>${processingOrderNo}
                </td>
              </tr>
              <tr>
                <td>采购单号</td>
                <td>${purchaseOrderNo}</td>
              </tr>
              <tr>
                <td>物料编号</td>
                <td>${materialNo}</td>
              </tr>
              <tr>
                <td>物料名称</td>
                <td>SMT IC</td>
              </tr>
              <tr>
                <td>规格型号</td>
                <td>${specificationNo}</td>
              </tr>
              <tr>
                <td>发货日期</td>
                <td>${dateCode}</td>
              </tr>
              <tr>
                <td>厂商批号</td>
                <td>${manufacturerLotNo}</td>
              </tr>
              <tr>
                <td>供应商</td>
                <td>${supplier}</td>
              </tr>
              <tr>
                <td colspan="2" style="word-break: break-all;padding: 0;">${batchNo}</td>
              </tr>
            </tbody>
          </table>
        </body>
    </html>
  `);
  const canvas = doc.getElementById(canvasId);
  QRCode.toCanvas(canvas, qrCodeText, {width: 150, margin: 2}, function (error) {
    if (error) console.error(error);
  });
  return iframe;
}

// 强力巨彩
export function initQiangLiJuCaiLabelFrame(
  {
    iframe,
    partNo,
    materialNo,
    orderNo,
    count,
    weight,
    deliveryDate,
    batchNo,
    index
  }) {
  let doc = iframe.contentWindow.document;
  let pageBreakBefore = index === undefined || index === 0 ? 'auto' : 'always';
  const dateCode = moment(deliveryDate).format('YYYY-MM-DD');
  doc.writeln(`
    <html>
      <head>
        <style type="text/css" media="print">
            @page {
                size: auto;
                margin: 0mm;
            }
        </style>
        <style type="text/css">
            * {
                margin: 0;
                padding: 0;
            }
            .qiangLiJuCaiLabel {
                border: 1px solid #000;
                margin: 0 5px;
                box-sizing: border-box;
                width: calc(100% - 10px);
                height: calc(100% - 30px);
                page-break-before:${pageBreakBefore};
                background: white;
                font-size: 12px;
                padding: 5px 10px 15px;
                font-family: ${fontFamily},serif;
            }
            .qiangLiJuCaiLabel .labelTitle {
                width: 80px;
                display: inline-block;
            }
            .qiangLiJuCaiLabel .label {
            }
            .qiangLiJuCaiLabel .boldText {
                font-weight: bold;
            }
            .qiangLiJuCaiLabel .unit {
                margin-left: 10px;
            }
            .qiangLiJuCaiLabel ul {
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                list-style: none;
            }
        </style>
    </head>
    <body>
        <div class="qiangLiJuCaiLabel">
            <ul>
                <li><span class="labelTitle">客户名称：</span><span class="label">厦门强力巨彩光电科技有限公司</span></li>
                <li><span class="labelTitle">品名/规格：</span><span class="label boldText">${partNo}</span></li>
                <li><span class="labelTitle">物料编号：</span><span class="label boldText">${materialNo}</span></li>
                <li><span class="labelTitle">订单号：</span><span class="label boldText">${orderNo}</span></li>
                <li><span class="labelTitle">数量：</span><span class="label boldText">${count}</span><span class="unit boldText">颗</span></li>
                <li><span class="labelTitle">重量：</span><span class="label boldText">${weight}</span><span class="unit boldText">KG</span></li>
                <li><span class="labelTitle">发货日期：</span><span class="label boldText">${dateCode}</span></li>
                <li><span class="labelTitle">强力批号：</span><span class="label boldText">${batchNo}</span></li>
            </ul>
        </div>
    </body>
    </html>
   `);
  return iframe;
}

// 强力巨彩V2
// 强力批号，批号规则：IC56+生产日期（四位，年份的最后两位数字+月份两位数字）+流水号（三位数，每月从001~999，
// 每个电路发一次货就是一个号,下月重新更新），如：同一天发了三个型号的产品，则IC56YYMM001，IC56YYMM002，IC56YYMM003，
// 第二天发的型号不论和前一天的是否一致都为：IC56YYMM004
export function initQiangLiJuCaiLabelV2Frame(
  {
    iframe,
    machineHandNo,
    partNo,
    materialNo,
    count,
    deliveryDate,
    trackingNo,
    index
  }) {
  let doc = iframe.contentWindow.document;
  let pageBreakBefore = index === undefined || index === 0 ? 'auto' : 'always';
  const dateCode = moment(deliveryDate).format('YYYY-MM-DD');
  const id = index === undefined ? '' : index;
  const supplierCode = 'IC56';
  doc.writeln(`
    <html>
      <head>
        <style type="text/css" media="print">
            @page {
                size: auto;
                margin: 0mm;
            }
        </style>
        <style type="text/css">
            * {
                margin: 0;
                padding: 0;
            }
            .qiangLiJuCaiLabelV2 {
                margin: 0 5px;
                font-size: 12px;
                box-sizing: border-box;
                background: white;
                page-break-before:${pageBreakBefore};
                width: calc(100% - 10px);
                height: calc(100% - 30px);
                border: 1px solid #000;
                border-collapse: collapse;
            }
            .qiangLiJuCaiLabelV2 .fontSize12 {
                font-size: 12px;
            }
            .qiangLiJuCaiLabelV2 .fontSize9 {
                font-size: 12px;
                zoom: 0.75;
            }
            .qiangLiJuCaiLabelV2 .fontSize8 {
                font-size: 12px;
                zoom: 0.7;
            }
            .qiangLiJuCaiLabelV2 td {
                padding: 1px 5px;
                line-height: 1;
                font-family: ${fontFamily},serif;
            }
            .qiangLiJuCaiLabelV2 .boldText {
                font-weight: bold;
            }
            .qiangLiJuCaiLabelV2 .barcodeText {
                margin-top: 3px;
            }

        </style>
    </head>
    <body>
        <table class="qiangLiJuCaiLabelV2" border="1" cellspacing="0" cellpadding="0">
             <tbody>
                <tr>
                    <td>物料名称：</td>
                    <td class="fontSize12">${machineHandNo}</td>
                </tr>
                <tr>
                    <td>规格型号：</td>
                    <td class="fontSize12">${partNo}</td>
                </tr>
                <tr>
                    <td>物料编号：</td>
                    <td><div id="QLV2MaterialNo${id}"></div><p class="fontSize12 barcodeText">${materialNo}</p></td>
                </tr>
                <tr>
                    <td>数量：</td>
                    <td><div id="QLV2Count${id}"></div><p class="fontSize12 barcodeText">${count}</p></td>
                </tr>
                <tr>
                    <td>批号/档次：</td>
                    <td><div id="QLV2BatchNo${id}"></div><p class="fontSize12 barcodeText">${trackingNo}</p></td>
                </tr>
                <tr>
                    <td>生产日期：</td>
                    <td class="fontSize12">${dateCode}</td>
                </tr>
                <tr>
                    <td>供应商代码：</td>
                    <td class="boldText">${supplierCode}</div></td>
                </tr>
             </tbody>
        </table>
    </body>
    </html>
   `);
  const settings = {
    output: 'bmp',
    bgColor: '#FFFFFF',
    color: '#000000',
    barWidth: 1,
    barHeight: 15,
    moduleSize: 5,
    posX: 1,
    posY: 0.1,
    addQuietZone: false,
    showHRI: false,
  };
  const type = 'code128';

  const viewQLV2MaterialNo = doc.getElementById(`QLV2MaterialNo${id}`);
  barcodeMethod.barcode(viewQLV2MaterialNo, materialNo, type, settings);
  const viewQLV2Count = doc.getElementById(`QLV2Count${id}`);
  barcodeMethod.barcode(viewQLV2Count, count + '', type, settings);
  const viewQLV2BatchNo = doc.getElementById(`QLV2BatchNo${id}`);
  barcodeMethod.barcode(viewQLV2BatchNo, trackingNo, type, settings);
  return iframe;
}

// 强力外箱加贴
export function initQiangLiBoxLabelFrame({
  iframe,
  partNo,
  trackingNo,
  lotNo,
  reserveInfo,
  index,
  lotNoIndex,
}) {
  let doc = iframe.contentWindow.document;
  let pageBreakBefore = index === undefined || index === 0 ? 'auto' : 'always';
  let lotTable = '';
  for (let row of reserveInfo) {
    lotTable += `<tr>
        <td class="tableInfoText">${row.lotNo}</td>
        <td class="tableInfoText">${row.cnt}</td>
    </tr>`;
  }
  for (let i = 0; i < 4 - reserveInfo.length; i++) {
    lotTable += `<tr>
        <td class="tableInfoText">&nbsp</td>
        <td class="tableInfoText">&nbsp</td>
    </tr>`;
  }
  doc.writeln(`
    <html>
        <head>
            <style type="text/css" media="print">
                @page {
                    size: auto;
                    margin: 0mm;
                }
            </style>
            <style type="text/css">
                * {
                    margin: 0;
                    padding: 0;
                }
                .qiangLiBoxLabel {
                    margin: 0 5px;
                    font-size: 12px;
                    box-sizing: border-box;
                    background: white;
                    page-break-before:${pageBreakBefore};
                    width: calc(100% - 10px);
                    height: calc(100% - 30px);
                    border-collapse: collapse;
                    padding: 5px;
                }
                .qiangLiBoxLabel p {
                    margin: 0 10px;
                }
                .qiangLiBoxLabel .boldText {
                    font-weight: bold;
                }
                .qiangLiBoxLabel table{
                    width: 100%;
                    border-collapse: collapse;
                }
                .qiangLiBoxLabel .tableInfoText {
                    padding: 0 0 0 3px;
                }
            </style>
        </head>
        <body>
            <div class="qiangLiBoxLabel">
              <p><span class="labelTitle boldText">规格型号：</span><span class="label">${partNo}</span></p>
              <p><span class="labelTitle boldText">批号/档次：</span><span class="label">${trackingNo}</span></p>
              <p><span class="labelTitle boldText">外箱批号：</span><span class="label">${lotNo}</span></p>
              <table border="1" cellspacing="0" cellpadding="0">
                 <tbody>
                    <tr>
                        <th class="boldText">印章${lotNoIndex || ''}</th>
                        <th class="boldText">数量</th>
                    </tr>
                    ${lotTable}
                 </tbody>
              </table>
            </div>
        </body>
    </html>
  `);
  return iframe;
}

// 利亚德 利亚德TV
export function initLiYaDeLabelFrame(
  {
    iframe,
    orderNo,
    materialNo,
    materialDescription,
    count,
    deliveryDate,
    productionBatch,
    index,
  }) {
  let doc = iframe.contentWindow.document;
  let pageBreakBefore = index === undefined || index === 0 ? 'auto' : 'always';
  const dateCode = moment(deliveryDate).format('YYYY-MM-DD');
  doc.writeln(`
  <html>
      <head>
        <style type="text/css" media="print">
            @page {
                size: auto;
                margin: 0mm;
            }
        </style>
        <style type="text/css">
            * {
                margin: 0;
                padding: 0;
            }
            .liYaDeabel {
                border: 1px solid #000;
                margin: 0 5px;
                box-sizing: border-box;
                width: calc(100% - 10px);
                height: calc(100% - 30px);
                page-break-before:${pageBreakBefore};
                background: white;
                font-size: 12px;
                padding: 5px 10px 15px;
                position: relative;
                font-family: ${fontFamily},serif;
            }
            .liYaDeabel ul {
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                list-style: none;
            }
            .liYaDeabel .boldText {
                font-weight: bold;
            }
            .liYaDeabel .rohsContainer {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }
            .liYaDeabel .rohsText {
                font-size: 14px;
                margin-right: 10px;
                border: 1px solid #000;
                border-radius: 50% / 50%;
                padding: 8px 15px;
                display: inline-block;
                font-weight: bold;
                align-self: center;
            }
            </style>
    </head>
    <body>
        <div class="liYaDeabel">
          <ul>
            <li><span class="labelTitle boldText">供应商编码：</span><span class="label">103018</span></li>
            <li><span class="labelTitle boldText">供应商全称：</span><span class="label">杭州视芯科技股份有限公司</span></li>
            <li><span class="labelTitle boldText">订单编号：</span><span class="label">${orderNo}</span></li>
            <li><span class="labelTitle boldText">LYD 物料编码：</span><span class="label">${materialNo}</span></li>
          </ul>
          <div class="rohsContainer">
            <ul>
              <li><span class="labelTitle boldText">LYD 物料描述：</span><span class="label">${materialDescription}</span></li>
              <li><span class="labelTitle boldText">数量：</span><span class="label">${count}</span></li>
              <li><span class="labelTitle boldText">发货日期：</span><span class="label">${dateCode}</span></li>
              <li><span class="labelTitle boldText">生产批次：</span><span class="label">${productionBatch}</span></li>
            </ul>
            <div>
                <span class="rohsText">RoHS</span>
            </div>
          </div>
        </div>
    </body>
    </html>
  `);
  return iframe;
}

// 易事达
export function initYiShiDaLabelFrame(
  {
    iframe,
    orderNo,
    customerMaterialNo,
    count,
    index,
  }) {
  let doc = iframe.contentWindow.document;
  let pageBreakBefore = index === undefined || index === 0 ? 'auto' : 'always';
  doc.writeln(`
  <html>
      <head>
        <style type="text/css" media="print">
            @page {
                size: auto;
                margin: 0mm;
            }
        </style>
        <style type="text/css">
            * {
                margin: 0;
                padding: 0;
            }
            .yiShiDaLabel {
                margin: 0 5px;
                box-sizing: border-box;
                width: calc(100% - 10px);
                height: 100%;;
                page-break-before:${pageBreakBefore};
                background: white;
                font-size: 18px;
                position: relative;
                font-family: ${fontFamily},serif;
                display: flex;
                display: -webkit-flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }
            .yiShiDaLabel ul {
                list-style: none;
            }
            .yiShiDaLabel .labelTitle {
                width: 100px;
                display: inline-block;
            }
            .yiShiDaLabel .boldText {
                font-weight: 500;
            }
        </style>
    </head>
    <body>
        <div class="yiShiDaLabel">
            <ul>
                <li><span class="labelTitle boldText">订单号：</span><span class="label boldText">${orderNo}</span></li>
                <li><span class="labelTitle boldText">客户料号：</span><span class="label boldText">${customerMaterialNo}</span></li>
                <li><span class="labelTitle boldText">数量：</span><span class="label boldText">${count} PCS</span></li>
            </ul>
        </div>
    </body>
    </html>
  `);
  return iframe;
}

// 巴科
export function initBaKeLabelFrame(data) {
  return labelForBaKeAndLeiManAndMeiKale(data);
}

// 惠州雷曼
export function initLeiManLabelFrame(data) {
  return labelForBaKeAndLeiManAndMeiKale(data);
}

// 美卡乐
export function initMeiKaLeLabelFrame(data) {
  return labelForBaKeAndLeiManAndMeiKale(data);
}

export function initCommonLabelFrame(data) {
  return labelForBaKeAndLeiManAndMeiKale(data);
}

function labelForBaKeAndLeiManAndMeiKale(
  {
    iframe,
    partNo,
    lotNo,
    qty,
    trackingNo,
    dateCode,
    packageType,
    result,
    marking,
    grossWeight,
    netWeight,
    binLevelExplain,
    customerMaterialNo,
    index,
  }) {
  let PN = partNo;
  let LOTNO = lotNo;
  let QTY = qty;
  let TrayNo = trackingNo;
  let DateCode = moment(dateCode).format('YYYY-MM-DD');
  let Marking = marking;
  let isBoxLabel = netWeight !== null && grossWeight !== null && netWeight !== undefined && grossWeight !== undefined;
  let binLevel = binLevelExplain || '';

  let doc = iframe.contentWindow.document;
  let pageBreakBefore = index === undefined || index === 0 ? 'auto' : 'always';
  let titleFontFamily = 'Microsoft YaHei, SimHei';
  let contentFontFamily = 'Microsoft YaHei, SimHei';
  const id = index === undefined ? '' : index;
  doc.writeln(`
        <html>
        <head>
            <style type="text/css" media="print">
                @page {
                    size: auto;
                    margin: 0mm;
                }
            </style>
            <style type="text/css">
                * {
                    margin: 0;
                    padding: 0;
                }
                .commonLabel {
                    border: 1px solid #000;
                    width: calc(100% - 10px);
                    height: calc(100% - 20px);
                    box-sizing: border-box;
                    position: relative;
                    margin: 0 5px;
                    page-break-before:${pageBreakBefore};
                    background: white;
                }
                .commonLabel .left-title {
                    margin-left: 12px;
                    margin-top: 1px;
                    margin-bottom: 2px;
                    font-family: ${titleFontFamily};
                }
                .commonLabel .right-title {
                    margin-left: 10px;
                    margin-top: 1px;
                    margin-bottom: 2px;
                    font-family: ${titleFontFamily};
                }
                .commonLabel .fontSize13 {
                    font-size: 13px;
                    zoom: 0.9;
                }
                .commonLabel .fontSize12 {
                    font-size: 12px;
                    zoom: 0.9;
                }
                .commonLabel .fontSize10 {
                    font-size: 12px;
                    zoom: 0.9;
                }
                .commonLabel .fontSize7 {
                    font-size: 12px;
                    zoom: 0.7;
                }
                .commonLabel .boldText {
                    font-weight: bold;
                }
                .commonLabel .left-barcode-container {
                    margin-left: 10px;
                }
                .commonLabel .right-barcode-container {
                    margin-left: 6px;
                }
                .commonLabel .content-title {
                    margin: -1px 0 0 6px;
                    font-family: ${contentFontFamily};
                }
                .commonLabel .passed {
                    font-size: 12px;
                    zoom: 0.7;
                    margin-right: 10px;
                    border: 1px solid #000;
                    border-radius: 50% / 50%;
                    padding: 5px 7px;
                    display: inline-block;
                    font-family: ${titleFontFamily},serif;
                }
                .commonLabel .customerMaterialNo {
                    margin-left: 50px;
                    margin-bottom: 3px;
                    font-family: ${titleFontFamily};
                }
                .commonLabel .underlineText {
                    border-bottom: 1px solid #000;
                }
            </style>
        </head>
        <body>
            <div class="commonLabel">
                <div style="left: 0; position: absolute; top: 0; z-index: 100; width: 100%; height: 100%;">
                    <p class="left-title boldText fontSize13">P/N:${PN}</p>
                    <div id="PN${id}" class="left-barcode-container"></div>
                    <p class="left-title fontSize12">LOT NO:${LOTNO}</p>
                    <div id="LOTNO${id}" class="left-barcode-container"></div>
                    <div style="display: flex; flex-direction: row; position: relative;">
                        <div>
                            <p class="left-title fontSize12">QTY:${QTY}</p>
                            <div id="QTY${id}" class="left-barcode-container"></div>
                        </div>
                        <div style="position: absolute; left: 39%; top: 5px;">
                            <span class="passed">${result ? 'PASSED' : 'FAILED'}</span>
                        </div>
                    </div>
                    <p class="left-title fontSize12">Tracking NO:${TrayNo}</p>
                    <div id="TrayNo${id}" class="left-barcode-container"></div>
                </div>
                <div style="left: 48%; top: 1px; z-index: 1; position: absolute;">
                  <p class="customerMaterialNo fontSize7">C/N:${customerMaterialNo}</p>
                  <div id="CustomerMaterialNo${id}" class="right-barcode-container"></div>
                </div>
                <span class="boldText fontSize12" style="font-family: ${titleFontFamily}; top: 1px; right: 15px; z-index: 1; position: absolute;">${binLevel}</span>
                <div style="left: 58%; top: 20%; z-index: 1; position: absolute;">
                    <p class="right-title fontSize7">Date Code:${DateCode}</p>
                    <div id="DateCode${id}" class="right-barcode-container"></div>
                    <p class="content-title"><span class="fontSize7 underlineText">Halogen Free</span></p>
                    <p class="content-title"><span class="fontSize7">Package:${packageType || ''}</span></p>
                    <p class="content-title"><span class="fontSize7">Marking:${Marking}</span></p>
                    <p class="content-title"><span class="fontSize7">Country of Origin China</span></p>
                    ${isBoxLabel ? `<p class="content-title"><span class="fontSize7">N.W./G.W.:${netWeight} Kg/${grossWeight} Kg</span></p>` : ''}
                </div>
            </div>
        </body>
    </html>
    `
  );

  const settings = {
    output: 'bmp',
    bgColor: '#FFFFFF',
    color: '#000000',
    barWidth: 1,
    barHeight: 20,
    moduleSize: 5,
    posX: 1,
    posY: 0.1,
    addQuietZone: false,
    showHRI: false,
  };
  const type = 'code128';

  const viewPN = doc.getElementById(`PN${id}`);
  barcodeMethod.barcode(viewPN, PN, type, settings);

  const viewLOTNO = doc.getElementById(`LOTNO${id}`);
  barcodeMethod.barcode(viewLOTNO, LOTNO, type, settings);

  const viewQTY = doc.getElementById(`QTY${id}`);
  barcodeMethod.barcode(viewQTY, QTY + '', type, settings);

  const viewTrayNo = doc.getElementById(`TrayNo${id}`);
  barcodeMethod.barcode(viewTrayNo, TrayNo, type, settings);

  const viewDateCode = doc.getElementById(`DateCode${id}`);
  barcodeMethod.barcode(viewDateCode, DateCode, type, settings);

  const viewCustomerMaterialNo = doc.getElementById(`CustomerMaterialNo${id}`);
  barcodeMethod.barcode(viewCustomerMaterialNo, customerMaterialNo, type, settings);

  return iframe;
}

// 健和
export function initJianHeLabelFrame(
  {
    iframe,
    materialNo,
    materialName,
    contractNo,
    deliveryDate,
    index,
  }) {
  let doc = iframe.contentWindow.document;
  let pageBreakBefore = index === undefined || index === 0 ? 'auto' : 'always';
  const dateCode = moment(deliveryDate).format('YYYY/M/D');
  doc.writeln(`
  <html>
      <head>
        <style type="text/css" media="print">
            @page {
                size: auto;
                margin: 0mm;
            }
        </style>
        <style type="text/css">
            * {
                margin: 0;
                padding: 0;
            }
            .jianHeLabel {
                margin: 0 5px;
                font-size: 12px;
                box-sizing: border-box;
                background: white;
                page-break-before:${pageBreakBefore};
                width: calc(100% - 10px);
                height: calc(100% - 30px);
                border: 1px solid #000;
                border-collapse: collapse;
            }
            .jianHeLabel td {
                padding: 0;
                font-family: ${fontFamily},serif;
            }
            .jianHeLabel td.jianHeLabelTitle {
                padding: 0 0 0 3px;
                font-family: ${fontFamily},serif;
            }
            </style>
      </head>
      <body>
          <table class="jianHeLabel" border="1" cellspacing="0" cellpadding="0">
              <tbody>
                  <tr align="center">
                      <td colspan="2">惠州健和光电有限公司</td>
                  </tr>
                  <tr>
                      <td class="jianHeLabelTitle">物料编码：</td>
                      <td align="center">${materialNo}</td>
                  </tr>
                  <tr>
                      <td class="jianHeLabelTitle">物料名称：</td>
                      <td align="center">${materialName}</td>
                  </tr>
                  <tr>
                      <td class="jianHeLabelTitle">合同号：</td>
                      <td align="center">${contractNo}</td>
                  </tr>
                  <tr>
                      <td class="jianHeLabelTitle">送货日期：</td>
                      <td align="center">${dateCode}</td>
                  </tr>
                  <tr>
                      <td class="jianHeLabelTitle">送货方：</td>
                      <td align="center">杭州视芯科技股份有限公司</td>
                  </tr>
              </tbody>
            </table>
       </body>
    </html>
  `);
  return iframe;
}

// 金立翔
export function initJinLiXiangLabelFrame(
  {
    iframe,
    orderNo,
    materialNo,
    materialDescription,
    count,
    deliveryDate,
    productionBatch,
    index,
  }) {
  let doc = iframe.contentWindow.document;
  let pageBreakBefore = index === undefined || index === 0 ? 'auto' : 'always';
  const dateCode = moment(deliveryDate).format('YYYY-MM-DD');
  doc.writeln(`
  <html>
      <head>
        <style type="text/css" media="print">
            @page {
                size: auto;
                margin: 0mm;
            }
        </style>
        <style type="text/css">
            * {
                margin: 0;
                padding: 0;
            }
            .jinLiXiangLabel {
                border: 1px solid #000;
                margin: 0 5px;
                box-sizing: border-box;
                width: calc(100% - 10px);
                height: calc(100% - 30px);
                page-break-before:${pageBreakBefore};
                background: white;
                font-size: 12px;
                padding: 5px 10px 15px;
                position: relative;
                font-family: ${fontFamily},serif;
            }
            .jinLiXiangLabel ul {
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                list-style: none;
            }
            .jinLiXiangLabel .boldText {
                font-weight: bold;
            }
            .jinLiXiangLabel .rohsContainer {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }
            .jinLiXiangLabel .rohsText {
                font-size: 14px;
                margin-right: 10px;
                border: 1px solid #000;
                border-radius: 50% / 50%;
                padding: 8px 15px;
                display: inline-block;
                font-weight: bold;
                align-self: center;
            }
            </style>
    </head>
    <body>
        <div class="jinLiXiangLabel">
          <div class="rohsContainer">
            <ul>
              <li><span class="labelTitle boldText">供应商编码：</span><span class="label">103018</span></li>
              <li><span class="labelTitle boldText">供应商全称：</span><span class="label">杭州视芯科技股份有限公司</span></li>
              <li><span class="labelTitle boldText">订单编号：</span><span class="label">${orderNo}</span></li>
              <li><span class="labelTitle boldText">物料编码：</span><span class="label">${materialNo}</span></li>
              <li><span class="labelTitle boldText">物料描述：</span><span class="label">${materialDescription}</span></li>
              <li><span class="labelTitle boldText">数量：</span><span class="label">${count}</span></li>
              <li><span class="labelTitle boldText">发货日期：</span><span class="label">${dateCode}</span></li>
              <li><span class="labelTitle boldText">生产批次：</span><span class="label">${productionBatch}</span></li>
            </ul>
            <div class="rohsContainer">
                <span class="rohsText">RoHS</span>
            </div>
          </div>
        </div>
    </body>
    </html>
  `);
  return iframe;
}

// 视芯
export function initShiXinLabelFrame(
  {
    iframe,
    partNo,
    lotNo,
    qty,
    trackingNo,
    dateCode,
    packageType,
    result,
    marking,
    grossWeight,
    netWeight,
    binLevelExplain,
    remark,
    index,
  }) {
  let PN = partNo;
  let LOTNO = lotNo;
  let QTY = qty;
  let TrayNo = trackingNo;
  let DateCode = moment(dateCode).format('YYYY-MM-DD');
  let Marking = marking;
  let isBoxLabel = netWeight !== null && grossWeight !== null
    && netWeight !== undefined && grossWeight !== undefined
    && netWeight !== '' && grossWeight !== '';
  let binLevel = binLevelExplain || '';

  let doc = iframe.contentWindow.document;
  let pageBreakBefore = index === undefined || index === 0 ? 'auto' : 'always';
  let titleFontFamily = 'Microsoft YaHei, SimHei';
  let contentFontFamily = 'Microsoft YaHei, SimHei';
  const id = index === undefined ? '' : index;
  doc.writeln(`
        <html>
        <head>
            <style type="text/css" media="print">
                @page {
                    size: auto;
                    margin: 0mm;
                }
            </style>
            <style type="text/css">
                * {
                    margin: 0;
                    padding: 0;
                }
                .shiXinLabel {
                    border: 1px solid #000;
                    width: calc(100% - 10px);
                    height: calc(100% - 20px);
                    box-sizing: border-box;
                    position: relative;
                    margin: 0 5px;
                    page-break-before:${pageBreakBefore};
                    background: white;
                }
                .shiXinLabel .left-title {
                    margin-left: 12px;
                    margin-top: 1px;
                    margin-bottom: 2px;
                    font-family: ${titleFontFamily};
                }
                .shiXinLabel .right-title {
                    margin-left: 10px;
                    margin-top: 1px;
                    margin-bottom: 2px;
                    font-family: ${titleFontFamily};
                }
                .shiXinLabel .fontSize15 {
                    font-size: 15px;
                }
                .shiXinLabel .fontSize13 {
                    font-size: 14px;
                    zoom: 0.9;
                }
                .shiXinLabel .fontSize12 {
                    font-size: 12px;
                    zoom: 0.9;
                }
                .shiXinLabel .fontSize10 {
                    font-size: 12px;
                    zoom: 0.8;
                }
                .shiXinLabel .fontSize7 {
                    font-size: 12px;
                    zoom: 0.7;
                }
                .shiXinLabel .boldText {
                    font-weight: bold;
                }
                .shiXinLabel .left-barcode-container {
                    margin-left: 10px;
                }
                .shiXinLabel .right-barcode-container {
                    margin-left: 6px;
                }
                .shiXinLabel .content-title {
                    margin: -1px 0 0 6px;
                    font-family: ${contentFontFamily};
                }
                .shiXinLabel .passed {
                    font-size: 12px;
                    zoom: 0.7;
                    margin-right: 10px;
                    border: 1px solid #000;
                    border-radius: 50% / 50%;
                    padding: 5px 7px;
                    display: inline-block;
                    font-family: ${titleFontFamily},serif;
                }
                .shiXinLabel .underlineText {
                    border-bottom: 1px solid #000;
                }
            </style>
        </head>
        <body>
            <div class="shiXinLabel">
                <div style="left: 0; position: absolute; top: 3px; z-index: 100; width: 100%; height: 100%;">
                    <p class="left-title boldText fontSize13">P/N:${PN}</p>
                    <div id="PN${id}" class="left-barcode-container"></div>
                    <p class="left-title boldText fontSize12">LOT NO:${LOTNO}</p>
                    <div id="LOTNO${id}" class="left-barcode-container"></div>
                    <div style="display: flex; flex-direction: row; position: relative;">
                        <div>
                            <p class="left-title boldText fontSize12">QTY:${QTY}</p>
                            <div id="QTY${id}" class="left-barcode-container"></div>
                        </div>
                        <div style="position: absolute; left: 39%; top: 5px;">
                            <span class="passed boldText">${result ? 'PASSED' : 'FAILED'}</span>
                        </div>
                    </div>
                    <p class="left-title fontSize12 boldText">Tracking NO:${TrayNo}</p>
                    <div id="TrayNo${id}" class="left-barcode-container"></div>
                </div>
                <div style="left: 58%; top: 8%; z-index: 1; position: absolute;">
                    ${remark ? `<p class="right-title boldText fontSize12">${remark}</p>` : ''}
                </div>
                <div style="left: 58%; top: 18%; z-index: 1; position: absolute;">
                    <p class="right-title boldText fontSize10">Date Code:${DateCode}</p>
                    <div id="DateCode${id}" class="right-barcode-container"></div>
                    <p class="content-title"><span class="fontSize7 boldText underlineText">Halogen Free</span></p>
                    <p class="content-title"><span class="fontSize7 boldText">Package:${packageType || ''}</span></p>
                    <p class="content-title"><span class="fontSize7 boldText">Marking:${Marking}</span></p>
                    <p class="content-title"><span class="fontSize7 boldText">Country of Origin China</span></p>
                    ${isBoxLabel ? `<p class="content-title"><span class="fontSize7 boldText">N.W./G.W.:${netWeight} Kg/${grossWeight} Kg</span></p>` : ''}
                </div>
                <span class="fontSize15 boldText" style="font-family: ${titleFontFamily}; top: 5px; right: 15%; z-index: 1; position: absolute;">${binLevel}</span>
            </div>
        </body>
    </html>
    `
  );

  const settings = {
    output: 'bmp',
    bgColor: '#FFFFFF',
    color: '#000000',
    barWidth: 1,
    barHeight: 20,
    moduleSize: 5,
    posX: 1,
    posY: 0.1,
    addQuietZone: false,
    showHRI: false,
  };
  const type = 'code128';

  const viewPN = doc.getElementById(`PN${id}`);
  barcodeMethod.barcode(viewPN, PN, type, settings);

  const viewLOTNO = doc.getElementById(`LOTNO${id}`);
  barcodeMethod.barcode(viewLOTNO, LOTNO, type, settings);

  const viewQTY = doc.getElementById(`QTY${id}`);
  barcodeMethod.barcode(viewQTY, QTY + '', type, settings);

  const viewTrayNo = doc.getElementById(`TrayNo${id}`);
  barcodeMethod.barcode(viewTrayNo, TrayNo, type, settings);

  const viewDateCode = doc.getElementById(`DateCode${id}`);
  barcodeMethod.barcode(viewDateCode, DateCode, type, settings);

  return iframe;
}

// 联建
export function initLianJianLabelFrame(
  {
    iframe,
    materialNo,
    materialName,
    contractNo,
    deliveryDate,
    index,
  }) {
  let doc = iframe.contentWindow.document;
  let pageBreakBefore = index === undefined || index === 0 ? 'auto' : 'always';
  const dateCode = moment(deliveryDate).format('YYYY/M/D');
  doc.writeln(`
  <html>
      <head>
        <style type="text/css" media="print">
            @page {
                size: auto;
                margin: 0mm;
            }
        </style>
        <style type="text/css">
            * {
                margin: 0;
                padding: 0;
            }
            .lianJianLabel {
                margin: 0 5px;
                font-size: 12px;
                box-sizing: border-box;
                background: white;
                page-break-before:${pageBreakBefore};
                width: calc(100% - 10px);
                height: calc(100% - 30px);
                border: 1px solid #000;
                border-collapse: collapse;
            }
            .lianJianLabel td {
                padding: 0;
                font-family: ${fontFamily},serif;
            }
            .lianJianLabel td.lianJianLabelTitle {
                padding: 0 0 0 3px;
                font-family: ${fontFamily},serif;
            }
            </style>
      </head>
      <body>
          <table class="lianJianLabel" border="1" cellspacing="0" cellpadding="0">
              <tbody>
                  <tr align="center">
                      <td colspan="2">惠州市联建光电有限公司</td>
                  </tr>
                  <tr>
                      <td class="lianJianLabelTitle">物料编码：</td>
                      <td align="center">${materialNo}</td>
                  </tr>
                  <tr>
                      <td class="lianJianLabelTitle">物料名称：</td>
                      <td align="center">${materialName}</td>
                  </tr>
                  <tr>
                      <td class="lianJianLabelTitle">合同号：</td>
                      <td align="center">${contractNo}</td>
                  </tr>
                  <tr>
                      <td class="lianJianLabelTitle">送货日期：</td>
                      <td align="center">${dateCode}</td>
                  </tr>
                  <tr>
                      <td class="lianJianLabelTitle">送货方：</td>
                      <td align="center">杭州视芯科技股份有限公司</td>
                  </tr>
              </tbody>
            </table>
       </body>
    </html>
  `);
  return iframe;
}

// 晶圆袋
export function initWaferLabelFrame({
  iframe,
  partNo,
  lotNo,
  waferCount,
  waferNo,
  prop,
  dateCode,
  qty,
  trackingNo,
  binLevelExplain,
  index,
}) {
  let PN = partNo;
  let LOTNO = lotNo;
  let QTY = qty;
  let TrayNo = trackingNo;
  let DateCode = moment(dateCode).format('YYYY/M/D');
  let doc = iframe.contentWindow.document;
  let pageBreakBefore = index === undefined || index === 0 ? 'auto' : 'always';
  let titleFontFamily = 'Microsoft YaHei, SimHei';
  let contentFontFamily = 'Microsoft YaHei, SimHei';
  let binLevel = binLevelExplain || '';
  const id = index === undefined ? '' : index;
  doc.writeln(`
        <html>
        <head>
            <style type="text/css" media="print">
                @page {
                    size: auto;
                    margin: 0mm;
                }
            </style>
            <style type="text/css">
                * {
                    margin: 0;
                    padding: 0;
                }
                .waferLabel {
                    width: calc(100% - 10px);
                    height: calc(100% - 15px);
                    box-sizing: border-box;
                    position: relative;
                    margin: 0 5px;
                    page-break-before:${pageBreakBefore};
                    background: white;
                    border: 1px solid #000;
                    border-radius: 20px;
                }
                .waferLabel .left-title {
                    margin-left: 12px;
                    margin-top: 1px;
                    margin-bottom: 1px;
                    font-family: ${titleFontFamily};
                }
                .waferLabel .right-title {
                    margin-left: 10px;
                    margin-top: 1px;
                    margin-bottom: 2px;
                    font-family: ${titleFontFamily};
                }
                .waferLabel .fontSize14 {
                    font-size: 14px;
                    zoom: 0.9;
                }
                .waferLabel .fontSize13 {
                    font-size: 13px;
                    zoom: 0.9;
                }
                .waferLabel .fontSize12 {
                    font-size: 12px;
                    zoom: 0.9;
                }
                .waferLabel .fontSize10 {
                    font-size: 12px;
                    zoom: 0.9;
                }
                .waferLabel .fontSize7 {
                    font-size: 12px;
                    zoom: 0.7;
                }
                .waferLabel .boldText {
                    font-weight: bold;
                }
                .waferLabel .left-barcode-container {
                    margin-left: 10px;
                }
                .waferLabel .right-barcode-container {
                    margin-left: 6px;
                    margin-top: 4px;
                    margin-bottom: 4px;
                }
                .waferLabel .content-title {
                    margin: 1px 0 0 6px;
                    font-family: ${contentFontFamily};
                }
                .waferLabel .rohsText {
                  font-size: 15px;
                  font-family: ${titleFontFamily};
                  border: 1px #67C23A solid;
                  color: #67C23A;
                  padding: 1px 2px;
                  display: inline-block;
                }
                .waferLabel .gpText {
                  font-size: 15px;
                  margin-top: 1px;
                  width: 30px;
                  height: 30px;
                  font-family: ${titleFontFamily};
                  color: #000;
                  background: #67C23A;
                  display: inline-block;
                  margin-left: 8px;
                  border-radius: 100%;
                  border: 1px solid #67C23A;
                  text-align: center;
                  line-height: 30px;
                }
            </style>
        </head>
        <body>
            <div class="waferLabel">
                <div style="left: 5px; position: absolute; top: 1px; z-index: 100;">
                    <p class="left-title fontSize12">P/N:${PN}</p>
                    <div id="PN${id}" class="left-barcode-container"></div>
                    <p class="left-title fontSize12">Lot No:${LOTNO}</p>
                    <div id="LOTNO${id}" class="left-barcode-container"></div>
                    <p class="left-title fontSize12">QTY:${waferCount}</p>
                    <div id="WAFER${id}" class="left-barcode-container"></div>
                    <p class="left-title fontSize12">Tracking No:${TrayNo}</p>
                    <div id="TrayNo${id}" style="zoom: 0.75;margin-left: 13px;" class="left-barcode-container"></div>
                    <p class="left-title fontSize12">WFR NO:${waferNo}</p>
                </div>
                <div style="left: 50%; top: 5px; z-index: 1; position: absolute;">
                    ${binLevel ? `<p class="content-title boldText fontSize14">${binLevel}</p>` : ''}
                </div>
                <div style="right: 32px; top: 36px; z-index: 1; position: absolute;">
                    <p class="content-title"><span class="fontSize12 underlineText">Prop:${prop || ''}</span></p>
                    <p class="content-title"><span class="fontSize12">Type:WAFER</span></p>
                    <p class="content-title"><span class="fontSize12">Date:${DateCode}</span></p>
                    <p class="content-title"><span class="fontSize12">Die:${QTY}</span></p>
                    <div id="QTY${id}" class="right-barcode-container"></div>
                </div>
            </div>
        </body>
    </html>
    `
  );

  const settings = {
    output: 'bmp',
    bgColor: '#FFFFFF',
    color: '#000000',
    barWidth: 1,
    barHeight: 20,
    moduleSize: 5,
    posX: 1,
    posY: 0.1,
    addQuietZone: false,
    showHRI: false,
  };
  const type = 'code128';

  const viewPN = doc.getElementById(`PN${id}`);
  barcodeMethod.barcode(viewPN, PN, type, settings);

  const viewLOTNO = doc.getElementById(`LOTNO${id}`);
  barcodeMethod.barcode(viewLOTNO, LOTNO, type, settings);

  const viewWaferCount = doc.getElementById(`WAFER${id}`);
  barcodeMethod.barcode(viewWaferCount, waferCount + '', type, settings);

  const viewTrayNo = doc.getElementById(`TrayNo${id}`);
  barcodeMethod.barcode(viewTrayNo, TrayNo, type, {
    ...settings,
    barHeight: 27
  });

  const viewQTY = doc.getElementById(`QTY${id}`);
  barcodeMethod.barcode(viewQTY, QTY + '', type, settings);

  return iframe;
}

// 晶圆角
export function initBoxLabelFrame({
  iframe,
  partNo,
  lotNo,
  waferNo,
  qty,
  binLevelExplain,
  index,
}) {
  let doc = iframe.contentWindow.document;
  let binLevel = binLevelExplain || '';
  let pageBreakBefore = index === undefined || index === 0 ? 'auto' : 'always';
  let titleFontFamily = 'Microsoft YaHei, SimHei';
  doc.writeln(`
  <html>
      <head>
        <style type="text/css" media="print">
            @page {
                size: auto;
                margin: 0mm;
            }
        </style>
        <style type="text/css">
            * {
                margin: 0;
                padding: 0;
            }
            .boxLabel {
                margin: 10px 5px;
                font-size: 16px;
                box-sizing: border-box;
                background: white;
                page-break-before:${pageBreakBefore};
                max-width: calc(100% - 10px);
                max-height: calc(100% - 30px);
                border: 1px solid #000;
                border-collapse: collapse;
                display: flex;
                justify-content: center;
                border-radius: 20px;
                font-family: ${titleFontFamily};
            }
            .boxLabel .fontSize14 {
                font-size: 14px;
                zoom: 0.9;
            }
            .boxLabel ul {
                list-style: none;
                margin: 10px 0;
            }
            .boxLabel .labelTitle {
                display: inline-block;
            }
            .boxLabel .boldText {
                font-weight: bold;
            }
            </style>
      </head>
      <body>
          <div class="boxLabel">
            <div style="right: 25%; top: 20px; z-index: 1; position: absolute;">
                ${binLevel ? `<p class="content-title boldText fontSize14">${binLevel}</p>` : ''}
            </div>
            <ul>
            <li><span class="labelTitle boldText">P/N：</span><span class="label boldText">${partNo}</span></li>
            <li><span class="labelTitle boldText">Lot No：</span><span class="label boldText">${lotNo}</span></li>
            <li><span class="labelTitle boldText">WFR No：</span><span class="label boldText">${waferNo}</span>
            <span class="labelTitle boldText" style="margin-left: 15px;">Die：</span><span class="label boldText">${qty}</span></li>
            </ul>
          </div>
       </body>
    </html>
  `);
  return iframe;
}

// 晶圆箱
export function initWaferBoxLabelFrame({
  iframe,
  partNo,
  lotNo,
  waferCount,
  dateCode,
  qty,
  trackingNo,
  binLevelExplain,
  index,
}) {
  let PN = partNo;
  let LOTNO = lotNo;
  let QTY = qty;
  let TrayNo = trackingNo;
  let DateCode = moment(dateCode).format('YYYY/M/D');
  let doc = iframe.contentWindow.document;
  let pageBreakBefore = index === undefined || index === 0 ? 'auto' : 'always';
  let titleFontFamily = 'Microsoft YaHei, SimHei';
  let contentFontFamily = 'Microsoft YaHei, SimHei';
  let binLevel = binLevelExplain || '';
  const id = index === undefined ? '' : index;
  doc.writeln(`
        <html>
        <head>
            <style type="text/css" media="print">
                @page {
                    size: auto;
                    margin: 0mm;
                }
            </style>
            <style type="text/css">
                * {
                    margin: 0;
                    padding: 0;
                }
                .waferBoxLabel {
                    width: calc(100% - 10px);
                    height: calc(100% - 15px);
                    box-sizing: border-box;
                    position: relative;
                    margin: 0 5px;
                    page-break-before:${pageBreakBefore};
                    background: white;
                    border: 1px solid #000;
                    border-radius: 20px;
                }
                .waferBoxLabel .left-title {
                    margin-left: 12px;
                    margin-top: 1px;
                    margin-bottom: 1px;
                    font-family: ${titleFontFamily};
                }
                .waferBoxLabel .right-title {
                    margin-left: 10px;
                    margin-top: 1px;
                    margin-bottom: 2px;
                    font-family: ${titleFontFamily};
                }
                .waferBoxLabel .fontSize14 {
                    font-size: 14px;
                    zoom: 0.9;
                }
                .waferBoxLabel .fontSize13 {
                    font-size: 13px;
                    zoom: 0.9;
                }
                .waferBoxLabel .fontSize12 {
                    font-size: 12px;
                    zoom: 0.9;
                }
                .waferBoxLabel .fontSize10 {
                    font-size: 12px;
                    zoom: 0.9;
                }
                .waferBoxLabel .fontSize7 {
                    font-size: 12px;
                    zoom: 0.7;
                }
                .waferBoxLabel .boldText {
                    font-weight: bold;
                }
                .waferBoxLabel .left-barcode-container {
                    margin-left: 10px;
                }
                .waferBoxLabel .right-barcode-container {
                    margin-left: 6px;
                    margin-top: 4px;
                    margin-bottom: 4px;
                }
                .waferBoxLabel .content-title {
                    margin: 1px 0 0 6px;
                    font-family: ${contentFontFamily};
                }
                .waferBoxLabel .rohsText {
                  font-size: 15px;
                  font-family: ${titleFontFamily};
                  border: 1px #67C23A solid;
                  color: #67C23A;
                  padding: 1px 2px;
                  display: inline-block;
                }
                .waferBoxLabel .gpText {
                  font-size: 15px;
                  margin-top: 1px;
                  width: 30px;
                  height: 30px;
                  font-family: ${titleFontFamily};
                  color: #000;
                  background: #67C23A;
                  display: inline-block;
                  margin-left: 8px;
                  border-radius: 100%;
                  border: 1px solid #67C23A;
                  text-align: center;
                  line-height: 30px;
                }
            </style>
        </head>
        <body>
            <div class="waferBoxLabel">
                <div style="left: 5px; position: absolute; top: 1px; z-index: 100;">
                    <p class="left-title fontSize12">P/N:${PN}</p>
                    <div id="PN${id}" class="left-barcode-container"></div>
                    <p class="left-title fontSize12">Lot No:${LOTNO}</p>
                    <div id="LOTNO${id}" class="left-barcode-container"></div>
                    <p class="left-title fontSize12">QTY:${waferCount}</p>
                    <div id="WAFER${id}" class="left-barcode-container"></div>
                    <p class="left-title fontSize12">Tracking No:${TrayNo}</p>
                    <div id="TrayNo${id}" style="zoom: 0.75;margin-left: 13px;" class="left-barcode-container"></div>
                </div>
                <div style="left: 50%; top: 5px; z-index: 1; position: absolute;">
                    ${binLevel ? `<p class="content-title boldText fontSize14">${binLevel}</p>` : ''}
                </div>
                <div style="right: 32px; top: 36px; z-index: 1; position: absolute;">
                    <p class="content-title"><span class="fontSize12 underlineText">C/O:CHINA</span></p>
                    <p class="content-title"><span class="fontSize12">Type:WAFER</span></p>
                    <p class="content-title"><span class="fontSize12">Date:${DateCode}</span></p>
                    <p class="content-title"><span class="fontSize12">Die:${QTY}</span></p>
                    <div id="QTY${id}" class="right-barcode-container"></div>
                </div>
            </div>
        </body>
    </html>
    `
  );

  const settings = {
    output: 'bmp',
    bgColor: '#FFFFFF',
    color: '#000000',
    barWidth: 1,
    barHeight: 20,
    moduleSize: 5,
    posX: 1,
    posY: 0.1,
    addQuietZone: false,
    showHRI: false,
  };
  const type = 'code128';

  const viewPN = doc.getElementById(`PN${id}`);
  barcodeMethod.barcode(viewPN, PN, type, settings);

  const viewLOTNO = doc.getElementById(`LOTNO${id}`);
  barcodeMethod.barcode(viewLOTNO, LOTNO, type, settings);

  const viewWaferCount = doc.getElementById(`WAFER${id}`);
  barcodeMethod.barcode(viewWaferCount, waferCount + '', type, settings);

  const viewTrayNo = doc.getElementById(`TrayNo${id}`);
  barcodeMethod.barcode(viewTrayNo, TrayNo, type, {
    ...settings,
    barHeight: 27,
  });

  const viewQTY = doc.getElementById(`QTY${id}`);
  barcodeMethod.barcode(viewQTY, QTY + '', type, settings);

  return iframe;
}

// 袋上的标签/B袋
export function initBagLabelFrame({
    iframe,
    partNo,
    lotNo,
    qty,
    waferNo,
    type,
    note,
    dateCode,
    binLevelExplain,
    index,
  }) {
    let PN = partNo;
    let LOTNO = lotNo;
    let QTY = qty;
    let DateCode = moment(dateCode).format('YYYY/M/D');
    let doc = iframe.contentWindow.document;
    let pageBreakBefore = index === undefined || index === 0 ? 'auto' : 'always';
    let titleFontFamily = 'Arial, SimHei';
    let contentFontFamily = 'Arial, SimHei';
    let binLevel = binLevelExplain || '';
    const id = index === undefined ? '' : index;
    const canvasId = index === undefined ? 'bagLabel' : `bagLabel_${index}`;
    doc.writeln(`
          <html>
          <head>
              <style type="text/css" media="print">
                  @page {
                      size: auto;
                      margin: 0mm;
                  }
              </style>
              <style type="text/css">
                  * {
                      margin: 0;
                      padding: 0;
                  }
                  .bagLabel {
                      width: calc(100% - 10px);
                      height: calc(100% - 15px);
                      box-sizing: border-box;
                      position: relative;
                      margin: 0 5px;
                      page-break-before:${pageBreakBefore};
                      background: white;
                      border: 1px solid #000;
                      border-radius: 0;
                      font-family: ${contentFontFamily};
                  }
                  .bagLabel .left-title {
                      margin-left: 12px;
                      margin-top: 3px;
                      margin-bottom: 1px;
                      font-family: ${titleFontFamily};
                  }
                  .bagLabel .waferNoText {
                    max-width: 220px;
                    word-break: break-all;
                    display: inline-block;
                  }
                  .bagLabel .right-title {
                      margin-left: 10px;
                      margin-top: 1px;
                      margin-bottom: 2px;
                      font-family: ${titleFontFamily};
                  }
                  .bagLabel .fontSize15 {
                      font-size: 15px;
                  }
                  .bagLabel .fontSize13 {
                      font-size: 13px;
                      zoom: 0.9;
                  }
                  .bagLabel .fontSize12 {
                      font-size: 12px;
                      zoom: 0.9;
                  }
                  .bagLabel .fontSize10 {
                      font-size: 12px;
                      zoom: 0.9;
                  }
                  .bagLabel .fontSize8 {
                    font-size: 12px;
                    zoom: 0.8;
                  }
                  .bagLabel .fontSize7 {
                      font-size: 12px;
                      zoom: 0.7;
                  }
                  .bagLabel .boldText {
                      font-weight: bold;
                  }
                  .bagLabel .left-barcode-container {
                      margin-left: 10px;
                  }
                  .bagLabel .right-barcode-container {
                      margin-left: 3px;
                      margin-top: 4px;
                      margin-bottom: 4px;
                  }
                  .bagLabel .content-title {
                      margin: 1px;
                      font-family: ${contentFontFamily};
                  }
                  .bagLabel .rohsText {
                    font-size: 15px;
                    font-family: ${titleFontFamily};
                    border: 1px #67C23A solid;
                    color: #67C23A;
                    padding: 1px 2px;
                    display: inline-block;
                  }
                  .bagLabel .gpText {
                    font-size: 15px;
                    margin-top: 1px;
                    width: 30px;
                    height: 30px;
                    font-family: ${titleFontFamily};
                    color: #000;
                    background: #67C23A;
                    display: inline-block;
                    margin-left: 8px;
                    border-radius: 100%;
                    border: 1px solid #67C23A;
                    text-align: center;
                    line-height: 30px;
                  }
              </style>
          </head>
          <body>
              <div class="bagLabel">
                  <div style="left: 5px; position: absolute; top: 1px; z-index: 100;">
                      <p class="left-title fontSize15 boldText">P/N:${PN}</p>
                      <div id="PN${id}" class="left-barcode-container"></div>
                      <p class="left-title fontSize15 boldText">Lot No.:${LOTNO}</p>
                      <div id="LOTNO${id}" class="left-barcode-container"></div>
                      <p class="left-title fontSize15 boldText">QTY:${qty}</p>
                      <div id="QTY${id}" class="left-barcode-container"></div>
                      <p class="left-title fontSize15 boldText">Date:${DateCode}</p>
                      <div id="DATECODE${id}" class="left-barcode-container"></div>
                      <p class="left-title fontSize12" style="display:flex;"><span>WFR NO.:</span><span class="waferNoText">${waferNo}</span></p>
                  </div>
                  <div style="left: 48%; top: 120px; z-index: 1; position: absolute;">
                      <p class="content-title"><span class="fontSize12">TYPE:${type || ''}</span></p>
                      <p class="content-title"><span class="fontSize12">NOTE:${note || ''}</span></p>
                  </div>
                  ${binLevel ? `<p class="content-title boldText fontSize15" style="right: 20px; top: 55px; z-index: 1; position: absolute;">${binLevel}</p>` : ''}
                  <canvas id="${canvasId}" style="zoom: 0.5; right: 20px; top: 88px; z-index: 1; position: absolute;"></canvas>
              </div>
          </body>
      </html>
      `
    );
  
    const settings = {
      output: 'bmp',
      bgColor: '#FFFFFF',
      color: '#000000',
      barWidth: 1,
      barHeight: 20,
      moduleSize: 5,
      posX: 1,
      posY: 0.1,
      addQuietZone: false,
      showHRI: false,
    };
    const codeType = 'code128';
  
    const viewPN = doc.getElementById(`PN${id}`);
    barcodeMethod.barcode(viewPN, PN, codeType, settings);
  
    const viewLOTNO = doc.getElementById(`LOTNO${id}`);
    barcodeMethod.barcode(viewLOTNO, LOTNO, codeType, settings);
  
    const viewQTY = doc.getElementById(`QTY${id}`);
    barcodeMethod.barcode(viewQTY, QTY + '', codeType, settings);

    const viewDateCode = doc.getElementById(`DATECODE${id}`);
    barcodeMethod.barcode(viewDateCode, DateCode, codeType, settings);
  
    const qrCodeText = `T:B;P:${partNo};L:${lotNo};Q:${qty};D:${DateCode};W:${waferNo};${binLevel ? `B:${binLevel}` : ''}`;
    const canvas = doc.getElementById(canvasId);
    QRCode.toCanvas(canvas, qrCodeText, {width: 190, margin: 0, errorCorrectionLevel: 'L'}, function (error) {
        if (error) console.error(error);
    });
    return iframe;
}

// 袋上的标签/C袋
export function initBagLabelCFrame({
    iframe,
    partNo,
    lotNo,
    qty,
    waferNo,
    type,
    note,
    dateCode,
    binLevelExplain,
    index,
  }) {
    let PN = partNo;
    let LOTNO = lotNo;
    let QTY = qty;
    let DateCode = moment(dateCode).format('YYYY/M/D');
    let doc = iframe.contentWindow.document;
    let pageBreakBefore = index === undefined || index === 0 ? 'auto' : 'always';
    let titleFontFamily = 'Arial, SimHei';
    let contentFontFamily = 'Arial, SimHei';
    let binLevel = binLevelExplain || '';
    const id = index === undefined ? '' : index;
    const canvasId = index === undefined ? 'bagLabelC' : `bagLabelC_${index}`;
    doc.writeln(`
          <html>
          <head>
              <style type="text/css" media="print">
                  @page {
                      size: auto;
                      margin: 0mm;
                  }
              </style>
              <style type="text/css">
                  * {
                      margin: 0;
                      padding: 0;
                  }
                  .bagLabel {
                      width: calc(100% - 10px);
                      height: calc(100% - 15px);
                      box-sizing: border-box;
                      position: relative;
                      margin: 0 5px;
                      page-break-before:${pageBreakBefore};
                      background: white;
                      border: 1px solid #000;
                      border-radius: 0;
                      font-family: ${contentFontFamily};
                  }
                  .bagLabel .left-title {
                      margin-left: 12px;
                      margin-top: 3px;
                      margin-bottom: 1px;
                      font-family: ${titleFontFamily};
                  }
                  .bagLabel .waferNoText {
                    max-width: 220px;
                    word-break: break-all;
                    display: inline-block;
                  }
                  .bagLabel .right-title {
                      margin-left: 10px;
                      margin-top: 1px;
                      margin-bottom: 2px;
                      font-family: ${titleFontFamily};
                  }
                  .bagLabel .fontSize15 {
                      font-size: 15px;
                  }
                  .bagLabel .fontSize13 {
                      font-size: 13px;
                      zoom: 0.9;
                  }
                  .bagLabel .fontSize12 {
                      font-size: 12px;
                      zoom: 0.9;
                  }
                  .bagLabel .fontSize10 {
                      font-size: 12px;
                      zoom: 0.9;
                  }
                  .bagLabel .fontSize8 {
                    font-size: 12px;
                    zoom: 0.8;
                  }
                  .bagLabel .fontSize7 {
                      font-size: 12px;
                      zoom: 0.7;
                  }
                  .bagLabel .boldText {
                      font-weight: bold;
                  }
                  .bagLabel .left-barcode-container {
                      margin-left: 10px;
                  }
                  .bagLabel .right-barcode-container {
                      margin-left: 3px;
                      margin-top: 4px;
                      margin-bottom: 4px;
                  }
                  .bagLabel .content-title {
                      margin: 1px;
                      font-family: ${contentFontFamily};
                  }
                  .bagLabel .rohsText {
                    font-size: 15px;
                    font-family: ${titleFontFamily};
                    border: 1px #67C23A solid;
                    color: #67C23A;
                    padding: 1px 2px;
                    display: inline-block;
                  }
                  .bagLabel .gpText {
                    font-size: 15px;
                    margin-top: 1px;
                    width: 30px;
                    height: 30px;
                    font-family: ${titleFontFamily};
                    color: #000;
                    background: #67C23A;
                    display: inline-block;
                    margin-left: 8px;
                    border-radius: 100%;
                    border: 1px solid #67C23A;
                    text-align: center;
                    line-height: 30px;
                  }
              </style>
          </head>
          <body>
              <div class="bagLabel">
                  <div style="left: 5px; position: absolute; top: 1px; z-index: 100;">
                      <p class="left-title fontSize15 boldText">P/N:${PN}</p>
                      <div id="PN${id}" class="left-barcode-container"></div>
                      <p class="left-title fontSize15 boldText">Lot No.:${LOTNO}</p>
                      <div id="LOTNO${id}" class="left-barcode-container"></div>
                      <p class="left-title fontSize15 boldText">QTY:${qty}</p>
                      <div id="QTY${id}" class="left-barcode-container"></div>
                      <p class="left-title fontSize15 boldText">Date:${DateCode}</p>
                      <div id="DATECODE${id}" class="left-barcode-container"></div>
                      <p class="left-title fontSize12" style="display:flex;"><span>WFR NO.:</span><span class="waferNoText">${waferNo}</span></p>
                  </div>
                  <div style="left: 48%; top: 120px; z-index: 1; position: absolute;">
                      <p class="content-title"><span class="fontSize12">TYPE:${type || ''}</span></p>
                      <p class="content-title"><span class="fontSize12">NOTE:${note || ''}</span></p>
                  </div>
                  ${binLevel ? `<p class="content-title boldText fontSize15" style="right: 20px; top: 55px; z-index: 1; position: absolute;">${binLevel}</p>` : ''}
                  <canvas id="${canvasId}" style="zoom: 0.5; right: 20px; top: 88px; z-index: 1; position: absolute;"></canvas>
              </div>
          </body>
      </html>
      `
    );
  
    const settings = {
      output: 'bmp',
      bgColor: '#FFFFFF',
      color: '#000000',
      barWidth: 1,
      barHeight: 20,
      moduleSize: 5,
      posX: 1,
      posY: 0.1,
      addQuietZone: false,
      showHRI: false,
    };
    const codeType = 'code128';
  
    const viewPN = doc.getElementById(`PN${id}`);
    barcodeMethod.barcode(viewPN, PN, codeType, settings);
  
    const viewLOTNO = doc.getElementById(`LOTNO${id}`);
    barcodeMethod.barcode(viewLOTNO, LOTNO, codeType, settings);
  
    const viewQTY = doc.getElementById(`QTY${id}`);
    barcodeMethod.barcode(viewQTY, QTY + '', codeType, settings);

    const viewDateCode = doc.getElementById(`DATECODE${id}`);
    barcodeMethod.barcode(viewDateCode, DateCode, codeType, settings);
  
    const qrCodeText = `T:C;P:${partNo};L:${lotNo};Q:${qty};D:${DateCode};W:${waferNo};${binLevel ? `B:${binLevel}` : ''}`;
    const canvas = doc.getElementById(canvasId);
    QRCode.toCanvas(canvas, qrCodeText, {width: 190, margin: 0, errorCorrectionLevel: 'L'}, function (error) {
        if (error) console.error(error);
    });
    return iframe;
}

// 蓝膜上的标签
export function initMembraneLabelFrame({
    iframe,
    partNo,
    lotNo,
    waferNo,
    qty,
    binLevelExplain,
    index,
  }) {
    let doc = iframe.contentWindow.document;
    let binLevel = binLevelExplain || '';
    let pageBreakBefore = index === undefined || index === 0 ? 'auto' : 'always';
    let titleFontFamily = 'Microsoft YaHei, SimHei';
    const canvasId = index === undefined ? 'membraneLabel' : `membraneLabel_${index}`;
    doc.writeln(`
    <html>
        <head>
          <style type="text/css" media="print">
              @page {
                  size: auto;
                  margin: 0mm;
              }
          </style>
          <style type="text/css">
              * {
                  margin: 0;
                  padding: 0;
              }
              .membraneLabel {
                  margin: 3px 3px;
                  font-size: 15px;
                  box-sizing: border-box;
                  background: white;
                  page-break-before:${pageBreakBefore};
                  max-width: calc(100% - 6px);
                  max-height: calc(100% - 6px);
                  border: 1px solid #000;
                  border-collapse: collapse;
                  border-radius: 0px;
                  font-family: ${titleFontFamily};
                  position: relative;
              }
              .membraneLabel .fontSize14 {
                  font-size: 14px;
                  zoom: 0.9;
              }
              .membraneLabel ul {
                  list-style: none;
                  margin: 3px 0;
              }
              .membraneLabel .labelTitle {
                  display: inline-block;
                  margin-left: 5px;
              }
              .membraneLabel .boldText {
                  font-weight: bold;
              }
              .membraneLabel .letterSpacingText {
                letter-spacing: -1px;
              }
              </style>
        </head>
        <body>
            <div class="membraneLabel">
              <div style="right: 5px; top: 3px; z-index: 1; position: absolute;">
                <canvas id="${canvasId}" style="zoom: 0.5;"></canvas>
              </div>
              <ul>
              <li><span class="labelTitle boldText letterSpacingText">P/N:</span><span class="label boldText letterSpacingText">${partNo}</span></li>
              <li><span class="labelTitle boldText letterSpacingText">Lot No.:</span><span class="label boldText letterSpacingText">${lotNo}</span></li>
              <li><span class="labelTitle boldText letterSpacingText">WFR No.:</span><span class="label boldText letterSpacingText">${waferNo}</span>
              <li><span class="labelTitle boldText letterSpacingText">Die:</span><span class="label boldText letterSpacingText">${qty}</span>
              </ul>
            </div>
         </body>
      </html>
    `);
    const qrCodeText = `T:A;P:${partNo};L:${lotNo};Q:${qty};W:${waferNo};${binLevel ? `B:${binLevel}` : ''}`;
    const canvas = doc.getElementById(canvasId);
    QRCode.toCanvas(canvas, qrCodeText, {width: 160, margin: 0, errorCorrectionLevel: 'L'}, function (error) {
        if (error) console.error(error);
    });
    return iframe;
  }

// 箱上的标签
export function initCaseLabelFrame({
    iframe,
    partNo,
    lotNo,
    qty,
    waferNo,
    type,
    note,
    dateCode,
    binLevelExplain,
    index,
  }) {
    let PN = partNo;
    let LOTNO = lotNo;
    let QTY = qty;
    let DateCode = moment(dateCode).format('YYYY/M/D');
    let doc = iframe.contentWindow.document;
    let pageBreakBefore = index === undefined || index === 0 ? 'auto' : 'always';
    let titleFontFamily = 'Arial, SimHei';
    let contentFontFamily = 'Arial, SimHei';
    let binLevel = binLevelExplain || '';
    const id = index === undefined ? '' : index;
    const canvasId = index === undefined ? 'caseLabel' : `caseLabel_${index}`;
    doc.writeln(`
          <html>
          <head>
              <style type="text/css" media="print">
                  @page {
                      size: auto;
                      margin: 0mm;
                  }
              </style>
              <style type="text/css">
                  * {
                      margin: 0;
                      padding: 0;
                  }
                  .caseLabel {
                      width: calc(100% - 10px);
                      height: calc(100% - 15px);
                      box-sizing: border-box;
                      position: relative;
                      margin: 0 5px;
                      page-break-before:${pageBreakBefore};
                      background: white;
                      border: 1px solid #000;
                      border-radius: 0;
                      font-family: ${contentFontFamily};
                  }
                  .caseLabel .left-title {
                      margin-left: 12px;
                      margin-top: 3px;
                      margin-bottom: 1px;
                      font-family: ${titleFontFamily};
                  }
                  .caseLabel .waferNoText {
                    max-width: 220px;
                    word-break: break-all;
                    display: inline-block;
                  }
                  .caseLabel .right-title {
                      margin-left: 10px;
                      margin-top: 1px;
                      margin-bottom: 2px;
                      font-family: ${titleFontFamily};
                  }
                  .caseLabel .fontSize15 {
                      font-size: 15px;
                  }
                  .caseLabel .fontSize13 {
                      font-size: 13px;
                      zoom: 0.9;
                  }
                  .caseLabel .fontSize12 {
                      font-size: 12px;
                      zoom: 0.9;
                  }
                  .caseLabel .fontSize10 {
                      font-size: 12px;
                      zoom: 0.9;
                  }
                  .caseLabel .fontSize8 {
                    font-size: 12px;
                    zoom: 0.8;
                  }
                  .caseLabel .fontSize7 {
                      font-size: 12px;
                      zoom: 0.7;
                  }
                  .caseLabel .boldText {
                      font-weight: bold;
                  }
                  .caseLabel .left-barcode-container {
                      margin-left: 10px;
                  }
                  .caseLabel .right-barcode-container {
                      margin-left: 3px;
                      margin-top: 4px;
                      margin-bottom: 4px;
                  }
                  .caseLabel .content-title {
                      margin: 1px;
                      font-family: ${contentFontFamily};
                  }
                  .caseLabel .rohsText {
                    font-size: 15px;
                    font-family: ${titleFontFamily};
                    border: 1px #67C23A solid;
                    color: #67C23A;
                    padding: 1px 2px;
                    display: inline-block;
                  }
                  .caseLabel .gpText {
                    font-size: 15px;
                    margin-top: 1px;
                    width: 30px;
                    height: 30px;
                    font-family: ${titleFontFamily};
                    color: #000;
                    background: #67C23A;
                    display: inline-block;
                    margin-left: 8px;
                    border-radius: 100%;
                    border: 1px solid #67C23A;
                    text-align: center;
                    line-height: 30px;
                  }
              </style>
          </head>
          <body>
              <div class="caseLabel">
                  <div style="left: 5px; position: absolute; top: 1px; z-index: 100;">
                      <p class="left-title fontSize15 boldText">P/N:${PN}</p>
                      <div id="PN${id}" class="left-barcode-container"></div>
                      <p class="left-title fontSize15 boldText">Lot No.:${LOTNO}</p>
                      <div id="LOTNO${id}" class="left-barcode-container"></div>
                      <p class="left-title fontSize15 boldText">QTY:${qty}</p>
                      <div id="QTY${id}" class="left-barcode-container"></div>
                      <p class="left-title fontSize15 boldText">Date:${DateCode}</p>
                      <div id="DATECODE${id}" class="left-barcode-container"></div>
                      <p class="left-title fontSize12" style="display:flex;"><span>WFR NO.:</span><span class="waferNoText">${waferNo}</span></p>
                  </div>
                  <div style="left: 48%; top: 110px; z-index: 1; position: absolute;">
                      <p class="content-title" style="margin-top: 2px;"><span class="fontSize12 underlineText">C/O:CHINA</span></p>
                      <p class="content-title"><span class="fontSize12">TYPE:${type || ''}</span></p>
                      <p class="content-title"><span class="fontSize12">NOTE:${note || ''}</span></p>
                  </div>
                  ${binLevel ? `<p class="content-title boldText fontSize15" style="right: 20px; top: 55px; z-index: 1; position: absolute;">${binLevel}</p>` : ''}
                  <canvas id="${canvasId}" style="zoom: 0.5; right: 20px; top: 88px; z-index: 1; position: absolute;"></canvas>
              </div>
          </body>
      </html>
      `
    );
  
    const settings = {
      output: 'bmp',
      bgColor: '#FFFFFF',
      color: '#000000',
      barWidth: 1,
      barHeight: 20,
      moduleSize: 5,
      posX: 1,
      posY: 0.1,
      addQuietZone: false,
      showHRI: false,
    };
    const codeType = 'code128';
  
    const viewPN = doc.getElementById(`PN${id}`);
    barcodeMethod.barcode(viewPN, PN, codeType, settings);
  
    const viewLOTNO = doc.getElementById(`LOTNO${id}`);
    barcodeMethod.barcode(viewLOTNO, LOTNO, codeType, settings);
  
    const viewQTY = doc.getElementById(`QTY${id}`);
    barcodeMethod.barcode(viewQTY, QTY + '', codeType, settings);

    const viewDateCode = doc.getElementById(`DATECODE${id}`);
    barcodeMethod.barcode(viewDateCode, DateCode, codeType, settings);
  
    const qrCodeText = `T:D;P:${partNo};L:${lotNo};Q:${qty};D:${DateCode};W:${waferNo};${binLevel ? `B:${binLevel}` : ''}`;
    const canvas = doc.getElementById(canvasId);
    QRCode.toCanvas(canvas, qrCodeText, {width: 190, margin: 0, errorCorrectionLevel: 'L'}, function (error) {
        if (error) console.error(error);
    });
    return iframe;
}
  
// 模块编号
export function initModuleNoLabelFrame({
    iframe,
    moduleNo,
    moduleNoQrCode,
    moduleNo1,
    moduleNoQrCode1,
    index,
  }) {
    let doc = iframe.contentWindow.document;
    let pageBreakBefore = index === undefined || index === 0 ? 'auto' : 'always';
    let titleFontFamily = 'Arial, SimHei';
    let contentFontFamily = 'Arial, SimHei';
    const id = index === undefined ? '' : index;
    const canvasId = index === undefined ? 'moduleNo' : `moduleNo_${index}`;
    const canvasId1 = index === undefined ? 'moduleNo_1' : `moduleNo_${index}_1`;
    doc.writeln(`
          <html>
          <head>
              <style type="text/css" media="print">
                  @page {
                      size: auto;
                      margin: 0mm;
                  }
              </style>
              <style type="text/css">
                  * {
                      margin: 0;
                      padding: 0;
                  }
                  .moduleNoLabel {
                      width: calc(100% - 10px);
                      height: calc(100% - 15px);
                      box-sizing: border-box;
                      position: relative;
                      margin: 0 5px;
                      page-break-before:${pageBreakBefore};
                      background: white;
                      border-radius: 0;
                      font-family: ${contentFontFamily};
                      display: flex;
                      align-items: center;
                      flex-direction: row;
                      padding: 0 20px;
                  }
                  .moduleNoLabel >div {
                    width: ${moduleNoQrCode1 ? '50%' : '100%'};
                    text-align: center;
                  }
                  .moduleNoLabel .title {
                      margin-top: 5px;
                      font-family: ${titleFontFamily};
                  }
                  .moduleNoLabel .fontSize15 {
                      font-size: 15px;
                  }
                  .moduleNoLabel .boldText {
                    font-weight: bold;
                }
              </style>
          </head>
          <body>
              <div class="moduleNoLabel">
                  <div>
                    <canvas id="${canvasId}" style="zoom: 0.5;"></canvas>
                    <p class="title fontSize15 boldText">${moduleNo}</p>
                  </div>
                  ${moduleNoQrCode1 ? `<div>
                    <canvas id="${canvasId1}" style="zoom: 0.5;"></canvas>
                    <p class="title fontSize15 boldText">${moduleNo1}</p>
                  </div>` : ''}
              </div>
          </body>
      </html>
      `
    );
    
    const qrCodeText = moduleNoQrCode || '';
    const canvas = doc.getElementById(canvasId);
    QRCode.toCanvas(canvas, qrCodeText, {width: 200, margin: 0, errorCorrectionLevel: 'L'}, function (error) {
        if (error) console.error(error);
    });

    const qrCodeText1 = moduleNoQrCode1 || '';
    if (qrCodeText1) {
        const canvas1 = doc.getElementById(canvasId1);
        QRCode.toCanvas(canvas1, qrCodeText1, {width: 200, margin: 0, errorCorrectionLevel: 'L'}, function (error) {
            if (error) console.error(error);
        });
    }
    return iframe;
}


// 视芯新标签 盘/铝箔袋/内盒标签
export function initShiXinLabelV2Frame(
{
    iframe,
    partNo,
    lotNo,
    qty,
    trackingNo,
    dateCode,
    packageType,
    result,
    marking,
    grossWeight,
    netWeight,
    binLevelExplain,
    remark,
    index,
}) {
    let PN = partNo;
    let LOTNO = lotNo;
    let QTY = qty;
    let TrayNo = trackingNo;
    let DateCode1 = moment(dateCode).format('YYYYMMDD');
    let DateCode2 = getWeek(DateCode1);
    let Marking = marking;
    let isBoxLabel = netWeight !== null && grossWeight !== null
    && netWeight !== undefined && grossWeight !== undefined
    && netWeight !== '' && grossWeight !== '';
    let binLevel = binLevelExplain || '';

    let doc = iframe.contentWindow.document;
    let pageBreakBefore = index === undefined || index === 0 ? 'auto' : 'always';
    let titleFontFamily = 'Arial,sans-serif';
    let contentFontFamily = 'Arial,sans-serif';
    const id = index === undefined ? '' : index;
    const canvasId = index === undefined ? 'shiXinLabelV2' : `shiXinLabelV2_${index}`;
    doc.writeln(`
            <html>
            <head>
                <style type="text/css" media="print">
                    @page {
                        size: auto;
                        margin: 0mm;
                        -webkit-print-color-adjust: exact;
                        print-color-adjust: exact;
                    }
                </style>
                <style type="text/css">
                    * {
                        margin: 0;
                        padding: 0;
                    }
                    .shiXinLabelV2 {
                        width: calc(100% - 10px);
                        height: calc(100% - 15px);
                        box-sizing: border-box;
                        position: relative;
                        margin: 0 5px;
                        page-break-before:${pageBreakBefore};
                        background: white;
                    }
                    .shiXinLabelV2 .left-title {
                        margin-left: 19px;
                        margin-top: 1px;
                        margin-bottom: 1px;
                        font-family: ${titleFontFamily};
                    }
                    .shiXinLabelV2 .right-title {
                        margin-top: 1px;
                        margin-bottom: 0;
                        font-family: ${titleFontFamily};
                    }
                    .shiXinLabelV2 .fontSize12 {
                        font-size: 14px;
                        zoom: 1.2;
                    }
                    .shiXinLabelV2 .fontSize9 {
                        font-size: 14px;
                        zoom: 0.9;
                    }
                    .shiXinLabelV2 .fontSize7 {
                        font-size: 14px;
                        zoom: 0.7;
                    }
                    .shiXinLabelV2 .fontSize6 {
                        font-size: 14px;
                        zoom: 0.6;
                    }
                    .shiXinLabelV2 .fontSize5 {
                        font-size: 14px;
                        zoom: 0.5;
                    }
                    .shiXinLabelV2 .boldText {
                        font-weight: bold;
                    }
                    .shiXinLabelV2 .left-barcode-container {
                        margin-left: 13px;
                    }
                    .shiXinLabelV2 .right-barcode-container {
                        margin-left: 6px;
                    }
                    .shiXinLabelV2 .content-title {
                        margin: -1px 0 0 6px;
                        font-family: ${contentFontFamily};
                    }
                    .shiXinLabelV2 .passed {
                        font-size: 12px;
                        zoom: 0.7;
                        margin-right: 10px;
                        border: 1px solid #000;
                        border-radius: 50% / 50%;
                        padding: 5px 7px;
                        display: inline-block;
                        font-family: ${titleFontFamily},serif;
                    }
                    .shiXinLabelV2 .underlineText {
                        border-bottom: 1px solid #000;
                    }
                    .shiXinLabelV2 .infoContainer {
                        display: flex;
                        margin-top: 2px;
                        margin-left: 8px;
                    }
                    .shiXinLabelV2 .infoContainer p {
                        min-width: 90px;
                    }
                    .shiXinLabelV2 .right-content-title {
                        margin: 0px 0 0 3px;
                        font-family: ${contentFontFamily};
                    }
                </style>
            </head>
            <body>
                <div class="shiXinLabelV2">
                    <div style="left: 0; position: absolute; top: 0; z-index: 100; width: 100%; height: 100%;">
                        <p class="left-title boldText fontSize9" style="margin-left: 15px;margin-top: 4px;">P/N:${PN}</p>
                        <div id="PN${id}" class="left-barcode-container"></div>
                        <p class="left-title boldText fontSize7">LOT NO:${LOTNO}</p>
                        <div id="LOTNO${id}" class="left-barcode-container"></div>
                        <div style="display: flex; flex-direction: row; position: relative;">
                            <div>
                                <p class="left-title boldText fontSize7">QTY:${QTY}</p>
                                <div id="QTY${id}" class="left-barcode-container"></div>
                            </div>
                            <div style="position: absolute; left: 39%; top: 13px;">
                                <span class="passed boldText">${result || 'PASSED'}</span>
                            </div>
                        </div>
                        <p class="left-title boldText fontSize7">Date Code:${DateCode2}</p>
                        <div id="DateCode${id}" class="left-barcode-container"></div>
                        <p class="left-title boldText fontSize7">Tracking NO:${TrayNo}</p>
                        <div>
                            <svg id="TrayNo${id}" class="left-barcode-container" style="margin-left: 14px;"></svg>
                        </div>
                        <div class="infoContainer" style="margin-top: 3px;position: relative">
                            <p class="content-title"><span class="fontSize5 boldText">Marking:${Marking}</span></p>
                            ${isBoxLabel ? `<p class="content-title"><span class="fontSize5 boldText">N.W./G.W.:${netWeight} Kg/${grossWeight} Kg</span></p>` : ''}
                            <span class="fontSize9 boldText" style="font-family: ${titleFontFamily}; line-height: 1; right: 10%; z-index: 1; position: absolute;">ROHS</span>
                        </div>
                        <div class="infoContainer">
                            <p class="content-title"><span class="fontSize5 boldText">Country of Origin China</span></p>
                            <p class="content-title"><span class="fontSize5 boldText">Package:${packageType || ''}</span></p>
                        </div>
                    </div>
                    <div style="left: 58%; top: 1px; z-index: 1; position: absolute;">
                        ${remark ? `<p class="right-title boldText fontSize9">${remark}</p>` : ''}
                    </div>
                    <canvas id="${canvasId}" style="zoom: 0.4; right: 10%; top: 60px; z-index: 1; position: absolute;"></canvas>
                    <div style="right: 10%; top: 90px; z-index: 1; position: absolute;">
                        <p class="right-content-title"><span class="fontSize6 boldText underlineText">Halogen Free</span></p>
                    </div>
                    <span class="fontSize12 boldText" style="font-family: ${titleFontFamily}; top: 1px; right: 16%; z-index: 1; position: absolute;">${binLevel}</span>
                </div>
            </body>
        </html>
        `
    );

    const settings = {
        output: 'bmp',
        bgColor: '#FFFFFF',
        color: '#000000',
        barWidth: 1,
        barHeight: 15,
        moduleSize: 5,
        posX: 1,
        posY: 0.1,
        addQuietZone: false,
        showHRI: false,
    };
    const type = 'code128';

    const viewPN = doc.getElementById(`PN${id}`);
    barcodeMethod.barcode(viewPN, PN, type, settings);

    const viewLOTNO = doc.getElementById(`LOTNO${id}`);
    barcodeMethod.barcode(viewLOTNO, LOTNO, type, settings);

    const viewQTY = doc.getElementById(`QTY${id}`);
    barcodeMethod.barcode(viewQTY, QTY + '', type, settings);

    const viewTrayNo = doc.getElementById(`TrayNo${id}`);
    viewTrayNo.imageSmoothingEnabled = false;
    // barcodeMethod.barcode(viewTrayNo, TrayNo, type, {
    //     ...settings,
    //     barHeight: 20,
    // });
    JsBarcode(viewTrayNo, TrayNo, {
        format: 'CODE128',
        lineColor: '#000000',
        width: 0.95,
        height: 22,
        displayValue: false,
        margin: 0,
    });

    const viewDateCode = doc.getElementById(`DateCode${id}`);
    barcodeMethod.barcode(viewDateCode, DateCode1, type, settings);

    let qrCodeText;
    let resultQrCode;
    if ((result || 'PASSED') === 'PASSED') {
        resultQrCode = 'PASSED';
    } else {
        resultQrCode = 'FAILED'
    }
    if (isBoxLabel) {
        qrCodeText = `LT:B;P:${partNo};L:${lotNo};Q:${qty};D1:${DateCode1};D2:${DateCode2};T:${TrayNo};${binLevel ? `B:${binLevel};` : ''}ROHS;${resultQrCode};SSOP24-24-225-0.635;1Q:${grossWeight};2Q:${netWeight}`;
    } else {
        qrCodeText = `LT:A;P:${partNo};L:${lotNo};Q:${qty};D1:${DateCode1};D2:${DateCode2};T:${TrayNo};${binLevel ? `B:${binLevel};` : ''}ROHS;${resultQrCode};SSOP24-24-225-0.635;9S:000`;
    }
    const canvas = doc.getElementById(canvasId);
    const size = 150;
    QRCode.toCanvas(canvas, qrCodeText, {width: size, margin: 0, errorCorrectionLevel: 'L'}, function (error) {
        if (error) console.error(error);
    });
    return iframe;
}

// 花蓝标签
export function initHuaLanLabelFrame(
{
    iframe,
    partNo,
    lotNo,
    qty,
    waferNo,
    note,
    prop,
    type,
    dateCode,
    cn,
    die,
    index,
}) {
    let PN = partNo;
    let LOTNO = lotNo;
    let QTY = qty;
    let DateCode = moment(dateCode).format('YYYY-MM-DD');

    let doc = iframe.contentWindow.document;
    let pageBreakBefore = index === undefined || index === 0 ? 'auto' : 'always';
    let titleFontFamily = 'Arial,sans-serif';
    let contentFontFamily = 'Arial,sans-serif';
    const id = index === undefined ? '' : index;
    doc.writeln(`
            <html>
            <head>
                <style type="text/css" media="print">
                    @page {
                        size: auto;
                        margin: 0mm;
                        -webkit-print-color-adjust: exact;
                        print-color-adjust: exact;
                    }
                </style>
                <style type="text/css">
                    * {
                        margin: 0;
                        padding: 0;
                    }
                    .huaLanLabel {
                        width: calc(100% - 10px);
                        height: calc(100% - 15px);
                        box-sizing: border-box;
                        position: relative;
                        margin: 0 5px;
                        page-break-before:${pageBreakBefore};
                        background: white;
                        border: 1px solid #000;
                    }
                    .huaLanLabel .headTitle {
                        font-size: 16px;
                        position: absolute;
                        left: 0;
                        right: 0;
                        top: 10px;
                        text-align: center;
                        font-family: ${titleFontFamily};
                    }
                    .huaLanLabel .headLeftTitle {
                        font-size: 18px;
                        position: absolute;
                        left: 30px;
                        top: 10px;
                        text-align: center;
                        font-family: ${titleFontFamily};
                    }
                    .huaLanLabel .left-title {
                        margin-left: 13px;
                        margin-top: 4px;
                        margin-bottom: 2px;
                        font-family: ${titleFontFamily};
                    }
                    .huaLanLabel .right-title {
                        margin-top: 4px;
                        margin-bottom: 2px;
                        font-family: ${titleFontFamily};
                    }
                    .huaLanLabel .fontSize12 {
                        font-size: 14px;
                        zoom: 1.2;
                    }
                    .huaLanLabel .fontSize9 {
                        font-size: 14px;
                        zoom: 0.9;
                    }
                    .huaLanLabel .fontSize7 {
                        font-size: 14px;
                        zoom: 0.7;
                    }
                    .huaLanLabel .fontSize6 {
                        font-size: 14px;
                        zoom: 0.6;
                    }
                    .huaLanLabel .fontSize5 {
                        font-size: 14px;
                        zoom: 0.5;
                    }
                    .huaLanLabel .boldText {
                        font-weight: bold;
                    }
                    .huaLanLabel .left-barcode-container {
                        margin-left: 13px;
                    }
                    .huaLanLabel .right-barcode-container {
                    }
                    .huaLanLabel .content-title {
                        margin: -1px 0 0 6px;
                        font-family: ${contentFontFamily};
                    }
                    .huaLanLabel .passed {
                        font-size: 12px;
                        zoom: 0.7;
                        margin-right: 10px;
                        border: 1px solid #000;
                        border-radius: 50% / 50%;
                        padding: 5px 7px;
                        display: inline-block;
                        font-family: ${titleFontFamily},serif;
                    }
                    .huaLanLabel .underlineText {
                        border-bottom: 1px solid #000;
                    }
                    .huaLanLabel .infoContainer {
                        display: flex;
                        margin-top: 2px;
                        margin-left: 8px;
                    }
                    .huaLanLabel .infoContainer p {
                        min-width: 90px;
                    }
                    .huaLanLabel .right-content-title {
                        margin: 0px 0 0 3px;
                        font-family: ${contentFontFamily};
                    }
                </style>
            </head>
            <body>
                <div class="huaLanLabel">
                    <p class="headTitle boldText">Product Certification</p>
                    <p class="headLeftTitle boldText">LS</p>
                    <div style="left: 0; position: absolute; top: 16%; z-index: 100; width: 100%;">
                        <p class="left-title boldText fontSize9" style="margin-left: 15px;margin-top: 4px;">P/N:${PN}</p>
                        <div id="PN${id}" class="left-barcode-container"></div>
                        <p class="left-title boldText fontSize9">Lot No:${LOTNO}</p>
                        <div id="LOTNO${id}" class="left-barcode-container"></div>
                        <p class="left-title boldText fontSize9">QTY:${QTY}</p>
                        <div id="QTY${id}" class="left-barcode-container"></div>
                        <p class="left-title boldText fontSize9">WFR No:${waferNo}</p>
                        <p class="left-title boldText fontSize9">NOTE:${note}</p>
                    </div>
                    <div style="left: 60%; top: 16%; z-index: 1; position: absolute;">
                        <p class="right-title boldText fontSize9">Prop:${prop}</p>
                        <p class="right-title boldText fontSize9" style="margin-top: 7px;">Type:${type}</p>
                        <p class="right-title boldText fontSize9">Date:${DateCode}</p>
                        <p class="right-title boldText fontSize9">C/N:${cn}</p>
                        <p class="right-title boldText fontSize9">Die:${die}</p>
                        <div id="DIE${id}" class="right-barcode-container"></div>
                    </div>
                </div>
            </body>
        </html>
        `
    );

    const settings = {
        output: 'bmp',
        bgColor: '#FFFFFF',
        color: '#000000',
        barWidth: 1,
        barHeight: 15,
        moduleSize: 5,
        posX: 1,
        posY: 0.1,
        addQuietZone: false,
        showHRI: false,
    };
    const barcodeType = 'code128';

    const viewPN = doc.getElementById(`PN${id}`);
    barcodeMethod.barcode(viewPN, PN, barcodeType, settings);

    const viewLOTNO = doc.getElementById(`LOTNO${id}`);
    barcodeMethod.barcode(viewLOTNO, LOTNO, barcodeType, settings);

    const viewQTY = doc.getElementById(`QTY${id}`);
    barcodeMethod.barcode(viewQTY, QTY + '', barcodeType, settings);

    const viewDie = doc.getElementById(`DIE${id}`);
    barcodeMethod.barcode(viewDie, die + '', barcodeType, settings);

    return iframe;
}


// 晶台
export function initJingTaiLabelFrame(
    {
        iframe,
        supplierCode,
        materialCode,
        materialName,
        specModel,
        qty,
        orderNo,
        dateCode,
        index,
    }) {
    let doc = iframe.contentWindow.document;
    let pageBreakBefore = index === undefined || index === 0 ? 'auto' : 'always';
    let fontFamily = 'Microsoft YaHei, SimHei';
    const DateCode = moment(dateCode).format('YYYY-M-D');
  doc.writeln(`
  <html>
      <head>
        <style type="text/css" media="print">
            @page {
                size: auto;
                margin: 0mm;
            }
        </style>
        <style type="text/css">
            * {
                margin: 0;
                padding: 0;
            }
            .jingTaiLabel {
                margin: 0 5px;
                box-sizing: border-box;
                background: white;
                page-break-before:${pageBreakBefore};
                width: calc(100% - 10px);
                height: calc(100% - 15px);
                font-family: ${fontFamily};
                font-size: 12px;
            }
            .jingTaiLabel p {
                text-align: center;
                font-family: ${fontFamily};
                font-size: 14px;
                margin: 5px 0;
            }
            .jingTaiLabel table {
                border: 1px solid #000;
            }
            .jingTaiLabel td {
                padding: 2px 0;
                vertical-align: middle;
                zoom: 0.7;
                border: 1px solid #000;
            }
            .jingTaiLabel tr:first-child td {
            }
            .jingTaiLabel .titleCell {
                width: 28%;
                text-align: center;
            }
            .jingTaiLabel .valueCell {
                text-align: center;
            }
            </style>
      </head>
      <body>
        <div class="jingTaiLabel">
          <p>苏州晶台物料标签</p>
          <table cellspacing="0" cellpadding="0" style="width: 100%; border-collapse: collapse;">
              <tbody>
                  <tr>
                    <td class="titleCell">供应商代码</td>
                    <td class="valueCell">${supplierCode || ''}</td>
                  </tr>
                  <tr>
                      <td class="titleCell">物料代码</td>
                      <td class="valueCell">${materialCode || ''}</td>
                  </tr>
                  <tr>
                      <td class="titleCell">物料名称</td>
                      <td class="valueCell">${materialName || ''}</td>
                  </tr>
                  <tr>
                      <td class="titleCell">规格型号</td>
                      <td class="valueCell">${specModel || ''}</td>
                  </tr>
                  <tr>
                      <td class="titleCell">数量</td>
                      <td class="valueCell">${qty != null ? qty : ''}PCS</td>
                  </tr>
                   <tr>
                      <td class="titleCell">订单号</td>
                      <td class="valueCell">${orderNo || ''}</td>
                  </tr>
                   <tr>
                      <td class="titleCell">生产日期</td>
                      <td class="valueCell">${DateCode || ''}</td>
                  </tr>
              </tbody>
            </table>
        </div>
       </body>
    </html>
  `);
  return iframe;
}

export function printFactoryLabel(iframe) {
  setTimeout(() => {
    if (!!window.ActiveXObject || "ActiveXObject" in window) { //是否ie
      remove_ie_header_and_footer();
    }
    iframe.contentWindow.focus();
    iframe.contentWindow.print();
  }, 200);
}